import { ContentSubtype } from "../../common/types/ContentSubtype";
import { RouteItem } from "../../core/routing/ProtectedRoute";
import {
    advertAssetsSearchRoute,
    featureDocumentaryAssetsSearchRoute,
    clientSpecificAssetsSearchRoute,
    movieAssetsSearchRoute,
    promoAssetsSearchRoute,
    safetyAssetsSearchRoute,
    shortFilmAssetsSearchRoute,
    tvSeriesAssetsSearchRoute,
    tvSingleAssetsSearchRoute,
    indentWarningAssetsSearchRoute
} from "../AssetsRoutes";

export const getSearchAssetRouteItemByContentSubtype = (key?: string | number): RouteItem => {
    switch (Number(key)) {
        case ContentSubtype.TV:
            return tvSeriesAssetsSearchRoute;

        case ContentSubtype.Movie:
            return movieAssetsSearchRoute;

        case ContentSubtype.TvSingle:
            return tvSingleAssetsSearchRoute;

        case ContentSubtype.FeatureDocumentary:
            return featureDocumentaryAssetsSearchRoute;

        case ContentSubtype.ShortFilm:
            return shortFilmAssetsSearchRoute;

        case ContentSubtype.Advert:
            return advertAssetsSearchRoute;

        case ContentSubtype.Promo:
            return promoAssetsSearchRoute;

        case ContentSubtype.Safety:
            return safetyAssetsSearchRoute;

        case ContentSubtype.IndentWarning:
            return indentWarningAssetsSearchRoute;

        case ContentSubtype.ClientSpecific:
            return clientSpecificAssetsSearchRoute;

        default:
            return tvSeriesAssetsSearchRoute;
    }
};
